import React from 'react';
import ModalFactory from 'react-modal-promise';
import { distanceDateTime } from 'utils';
import {
  Menu, MenuItem, DotButton, ItemIcon,
} from '../../../../components/CustomMenu';
import IUser from 'interfaces/user';
import { Container, WrapperMenu } from './styles';
import Flex, { Grid } from '../../../../components/Flex';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import { ListIcon } from 'styles/icons';
import { useHistory } from 'react-router';

interface IPartner {
  id: string;
  user: IUser;
  partner_name: string;
  created_at: string;
  server_time: string;
}

// eslint-disable-next-line arrow-body-style
const Card: React.FC<{ partner: IPartner }> = ({ partner }) => {
  const history = useHistory();
  
  return (
    <Container>
      <WrapperMenu>
        <PopupState variant="popover" popupId="demo-popup-menu">
          {(popupState) => (
            <>
              <DotButton {...bindTrigger(popupState)} />
              <Menu {...bindMenu(popupState)}>
                <MenuItem
                  onClick={() => { history.push(`/social-action/partners/edit/${partner.id}`); }}
                  style={{ width: 150 }}
                >
                  <ItemIcon icon={<ListIcon />} title="Editar" />
                </MenuItem>
              </Menu>
            </>
          )}
        </PopupState>
      </WrapperMenu>
      <Grid container spacing={1}>
        <Flex title="Responsável" xs={6} sm={6} md={4}>
          {partner.user.name || 'Não cadastrado'}
        </Flex>
        <Flex title="Parceiro" xs={6} sm={6} md={4}>
          {partner.partner_name}
        </Flex>
        <Flex title="Criado há" xs={6} sm={6} md={4}>
          {distanceDateTime(partner.created_at, partner.server_time, false)}
        </Flex>
      </Grid>
      <ModalFactory />
    </Container>
  );
};

export default Card;
